module.exports = __webpack_public_path__ + "img/draw_point.1e9935b6.png";